// extracted by mini-css-extract-plugin
module.exports = {"duration":"CallDuration_duration__pVD3p","spin360":"CallDuration_spin360__3vrpF"};